const pageNameKey = "replaceBlueprintGradientBox";

export const replaceBlueprintGradientBoxEn = {
  [pageNameKey]: { arrowBlueIconAltText: "Blue arrow" },
};

export const replaceBlueprintGradientBoxPtBr = {
  [pageNameKey]: { arrowBlueIconAltText: "Seta azul" },
};

export const replaceBlueprintGradientBoxDe = {
  [pageNameKey]: { arrowBlueIconAltText: "Blauer Pfeil" },
};

export const replaceBlueprintGradientBoxZhHans = {
  [pageNameKey]: { arrowBlueIconAltText: "蓝色箭头" },
};

export const replaceBlueprintGradientBoxIt = {
  [pageNameKey]: { arrowBlueIconAltText: "Freccia Blu" },
};

export const replaceBlueprintGradientBoxEs = {
  [pageNameKey]: { arrowBlueIconAltText: "Flecha azul" },
};

export const replaceBlueprintGradientBoxNl = {
  [pageNameKey]: {
    arrowBlueIconAltText: "Blauwe pijl",
  },
};

export const replaceBlueprintGradientBoxTr = {
  [pageNameKey]: {
    arrowBlueIconAltText: "Mavi ok",
  },
};
